import React, {useEffect} from 'react'
// import Card from 'react-bootstrap/Card';

import MainLayout from '../../components/layouts/MainLayout'
// import Hero from '../../components/home/Hero';
import Carousel from '../../components/home/Carousel'
import TalentaCards from '../../components/home/TalentaCards'

// import Features from '../../components/home/Features';
import Section from '../../components/common/Section'
// import Container from '../../components/common/Container';
// import Badge from '../../components/common/Badge';
import Blog from 'landing-page/components/home/Blog'
import CoP from 'landing-page/components/home/CoP'
import Overview from 'landing-page/components/home/Overview'
import Impact from 'landing-page/components/home/Impact'
// import SectionHeader from 'landing-page/components/home/SectionHeader';
import {Alumni} from 'landing-page/components/home/Alumni'
import CTA from 'landing-page/components/layout/CTA'

const HomePage: React.FC = () => {
  // Add CSS animations
  useEffect(() => {
    const style = document.createElement('style')
    style.textContent = `
      @keyframes gradientShift {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
      
      @keyframes gradientShiftHorizontal {
        0% { background-position: 0% 50%; }
        100% { background-position: 200% 50%; }
      }
      
      @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-10px); }
      }
      
      @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
      }
      
      .card-hover {
        transition: all 0.3s ease;
        cursor: pointer;
      }
      
      .card-hover:hover {
        transform: translateY(-8px);
        box-shadow: 0 20px 40px rgba(0,0,0,0.1) !important;
      }
      
      .arrow-hover {
        transition: all 0.3s ease;
      }
      
      .card-hover:hover .arrow-hover {
        transform: translateX(8px);
      }
      
      .card-link {
        transition: all 0.3s ease;
        text-decoration: none;
      }
      
      .card-hover:hover .card-link {
        color: #FF6B35 !important;
      }
      
      .icon-bounce {
        animation: float 2s ease-in-out infinite;
      }
      
      .number-pulse {
        animation: pulse 2s ease-in-out infinite;
      }
    `
    document.head.appendChild(style)

    return () => {
      document.head.removeChild(style)
    }
  }, [])

  const talentaCardsData = [
    {
      id: 'tesis-dan-disertasi',
      title_id: 'Tesis dan Disertasi',
      deskripsi_id: 'Kumpulan karya ilmiah alumni untuk kontribusi nyata.',
      image_id: require('landing-page/assets/img/thesis.png'),
      link_text_id: 'Lihat Tesis',
      link_url_id: '/content',
      is_active: '1',
    },
    {
      id: 'lowongan-pekerjaan',
      title_id: 'Lowongan Pekerjaan',
      deskripsi_id: 'Temukan peluang kerja sesuai keahlian Anda',
      image_id: require('landing-page/assets/img/loker.png'),
      link_text_id: 'Cari Lowongan',
      link_url_id: '/auth',
      is_active: '1',
    },
    {
      id: 'pana',
      title_id: 'PANA',
      deskripsi_id: 'Program Pengabdian Alumni LPDP Wujud nyata kontribusi alumni di masyarakat.',
      image_id: require('landing-page/assets/img/pana.png'),
      link_text_id: 'Ikut PANA',
      link_url_id: '/auth',
      is_active: '1',
    },
    {
      id: 'tracer-alumni',
      title_id: 'Tracer Alumni',
      deskripsi_id: 'Telusuri jejak dan dampak alumni setelah lulus.',
      image_id: require('landing-page/assets/img/tracer.png'),
      link_text_id: 'Lihat Tracer',
      link_url_id: 'https://traceralumni-lpdp.kemenkeu.go.id',
      is_active: '1',
    },
  ]

  return (
    <MainLayout>
      <Section variant='light-orange' id='carousel' className='mt-15'>
        <Carousel autoFetch={true} carouselType='header_1' />
      </Section>

      <Section variant='light-orange' id='talenta-cards' className='py-15'>
        <TalentaCards autoFetch={false} carouselType='header_2' items={talentaCardsData} />
      </Section>

      <Section variant='white' id='alumni-cards' className='py-15'>
        <Alumni autoFetch={true} />
      </Section>

      <Section variant='white' id='cta' className='py-15'>
        <CTA />
      </Section>

      <Section variant='white' id='blog' className='py-15'>
        <Blog autoFetch={true} />
      </Section>

      <Section variant='white' id='cop' className='py-15'>
        <CoP />
      </Section>

      <Section variant='light-orange' id='overview' className='py-15'>
        <Overview />
      </Section>

      <Section variant='white' id='impact' className='py-15'>
        <Impact />
      </Section>
    </MainLayout>
  )
}

export default HomePage
